import type { NextPage } from 'next';
import Bookis from '@components/projects/bookis/bookis';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { ProjectProps } from '@models/project.interface';

const BookisPage: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout project={project}>
      <Bookis breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default BookisPage;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
